import requerimentos from './requerimentos';
import termosDeCompromisso from './termosDeCompromisso';
import apolices from './apolices';
import concedentes from './concedentes';
import camposDeEstagio from './camposDeEstagio';
import atestesDeCampo from './atestesDeCampo';
import cursos from './cursos';
import estagios from './estagios';
import auth from './auth';

export const host = 'https://euizwpcdas.us16.qoddiapp.com';

export async function publicClient({ headers = {}, params = {}, ...props }) {
	const defaultRequestParams = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			Authorization: `Bearer ${auth.accessToken()}`,
			...headers,
		},
		mode: 'cors',
	};

	const requestParams = { ...defaultRequestParams, ...params };

	const uri = props.url ? props.url : `${host}${props.path || ''}`;

	const res = await fetch(uri, requestParams);

	if (res.ok) {
		return await res.json();
	} else if (res.status === 401) {
		auth.logout();
		throw new Error('Acesso não autorizado');
	}

	return await res.text();
}

export function privateClient(args) {
	const headers = {
		...(args.headers || {}),
		Authorization: `Bearer ${auth.accessToken()}`,
	};
	return publicClient({ ...args, headers });
}

const api = {
	apolices,
	atestesDeCampo,
	auth,
	camposDeEstagio,
	concedentes,
	cursos,
	requerimentos,
	termosDeCompromisso,
	estagios,
};

export default api;
